import apiBase from "../../api/axios";

const BASE = "v1/talentos-plantel/conversaciones";

/* ------------------------------------------------------------------ */
/*  CRUD principal                                                     */
/* ------------------------------------------------------------------ */

export const listarConversacionesPlantelService = async (plantelId) => {
  const response = await apiBase.get(`${BASE}/?plantel=${plantelId}`);
  return response.data;
};

export const obtenerConversacionPlantelService = async (id) => {
  const response = await apiBase.get(`${BASE}/${id}/`);
  return response.data;
};

export const crearConversacionPlantelService = async (payload) => {
  const response = await apiBase.post(`${BASE}/`, payload);
  return response.data;
};

export const actualizarConversacionPlantelService = async (id, payload) => {
  const response = await apiBase.patch(`${BASE}/${id}/`, payload);
  return response.data;
};

export const toggleActiveConversacionPlantelService = async (id) => {
  const response = await apiBase.post(`${BASE}/${id}/toggle_active/`);
  return response.data;
};

/* ------------------------------------------------------------------ */
/*  Selectores (para dropdowns)                                        */
/* ------------------------------------------------------------------ */

export const listarSelectoresConversacionesPlantelService = async (plantelId, search = "") => {
  let url = `v1/talentos-plantel/selectores/conversaciones/?plantel=${plantelId}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  const response = await apiBase.get(url);
  return response.data;
};
